export const DELETE_CUSTOMER_PASSWORD = "NMTD1923";
export const API_LIMIT = 100;
